import { Navigate, Outlet } from 'react-router-dom';

import { useFlag } from './FlagContext.jsx';
import { HELP_PATH } from '../navigation/paths.js';

// A layout route for pages that exist only behind a development flag: renders its
// child routes while the user has `flag` active and sends anyone else to `to`.
// The app only hides the menu entries and leaves the screens registered; on the
// web a page has an address anyone can type, so the gate sits on the route too.
export default function FlagGate({ flag, to = HELP_PATH }) {
  return useFlag(flag) ? <Outlet /> : <Navigate to={to} replace />;
}
